// @flow
import { combineReducers } from 'redux';

import * as types from '../types/gateways';
import * as studentTypes from '../types/students';
import * as gatewayUserActionType from '../types/gatewayUserActions';
import * as common from './common';
import type { ERROR_TYPE } from '../types/common';
import type { GATEWAY_USER_ACTION_TYPE } from '../types/gatewayUserActions';

export type GatewayUserActionState = {
  byId: { [number]: GATEWAY_USER_ACTION_TYPE },
  order: Array<number>,
  isFetching: boolean,
  isFetchingGatewayUsers: boolean,
  errors: { [number]: ERROR_TYPE }
};

const byId = common.byId({
  added: [studentTypes.FETCH_STUDENT_GATEWAYS_STARTED],
  fetched: [gatewayUserActionType.GATEWAY_USER_ACTION_FETCH_SUCCESS],
});

const errors = common.errors({
  populate: [types.GATEWAYS_FETCH_FAILED],
  clear: [types.GATEWAYS_FETCH_FAILED],
});

const isFetching = common.isFetching({
  started: [studentTypes.FETCH_STUDENT_GATEWAYS_STARTED],
  succeed: [
    gatewayUserActionType.GATEWAY_USER_ACTION_FETCH_SUCCESS,
  ],
  failed: [gatewayUserActionType.GATEWAY_USER_ACTION_FETCH_SUCCESS],
});

const order = common.order({
  fetched: [gatewayUserActionType.GATEWAY_USER_ACTION_FETCH_SUCCESS],
  added: [gatewayUserActionType.GATEWAY_USER_ACTION_FETCH_SUCCESS],
});

const isFetchingGatewayUsers = common.isFetching({
  started: [types.GATEWAY_USERS_FETCH_STARTED],
  succeed: [
    types.GATEWAY_USERS_FETCH_SUCCESS,
    types.UPDATE_GATEWAY_USERS_SUCCEED,
  ],
  failed: [types.GATEWAYS_USERS_FETCH_FAILED],
});

const gatewayUserActions = combineReducers({
  byId,
  errors,
  isFetching,
  order,
  isFetchingGatewayUsers,
});


export default gatewayUserActions;

export const getGatewayUserAction = (
  state: GatewayUserActionState,
  id: number,
): GATEWAY_USER_ACTION_TYPE => state.byId[id];

export const getGatewayUserActionIsFetching = (
  state: GatewayUserActionState,
): boolean => state.isFetching;

export const areGatewayUsersFetching = (
  state: GatewayUserActionState,
): boolean => state.isFetchingGatewayUsers;



// WEBPACK FOOTER //
// ./src/scripts/reducers/gatewayUserActions.js